<template>
  <nav>
    <!-- h2>Dashboard</h2>
    <menu>
      <NavLink to="/" label="Home" icon="home" tooltip="Home" />
    </menu -->

    <h2>Allotments</h2>
    <menu>
      <NavLink to="/allotments" :notifications="rejectionsCount ?? undefined" label="Overview" icon="list" tooltip="Allotments Overview"/>
      <NavLink to="/allotments/evolution" label="Evolution" icon="timeline" tooltip="Allotments Evolution" />
    </menu>

    <span v-if="isFlightSearchAllowed">
      <h2>Flight Search</h2>
      <menu>
        <NavLink to="/search-flights" label="Search for flights" icon="search" tooltip="Search for flights" />
        <NavLink to="/purchase-overview" label="Purchase overview" icon="list" tooltip="Purchase overview" />
      </menu>
    </span>

    <span v-if="isPaxDataAllowed">
      <h2>Passengers</h2>
      <menu>
        <NavLink to="/passenger-data" label="Overview" icon="history" tooltip="Passengers Overview"/>
        <NavLink :to="{ name: 'passengerData', query: { upload: null }}" label="Upload" icon="upload" tooltip="Passengers Upload"/>
      </menu>
    </span>

    <h2>Reports</h2>
    <menu>
      <NavLink to="/reports/generate" label="Generate report" icon="analytics" tooltip="Generate Reports"/>
      <NavLink to="/reports" label="Overview" icon="history" tooltip="Reports Overview"/>
    </menu>

    <span v-if="isTourOperatorAllAccess || isTourOperatorOnlyReporting">
      <h2>Schedule changes</h2>
      <menu>
        <NavLink to="/schedule-changes" label="Overview" icon="history" tooltip="Schedule changes overview" />
      </menu>
    </span>
  </nav>
</template>
<script lang="ts">
import {mapActions, mapState} from 'pinia';

import {useTourOperatorsStore} from '@/stores';

import NavLink from '@/components/structure/NavLink.vue';
import {useCurrentUserStore} from "@/stores/current-user-store.ts";
import {useAllotmentsStore} from "@/Features/Allotments/stores/allotment-store.ts";

export default {
  components: {
    NavLink,
  },
  data: function () {
    return {
      isPaxDataAllowed: false,
      isFlightSearchAllowed: false,
    }
  },
  computed: {
    ...mapState(useAllotmentsStore, {
      rejectionsCount: 'rejectionsCount',
    }),
    ...mapState(useCurrentUserStore, [
      'isTourOperatorOnlyReporting',
      'isTourOperatorAllAccess'
    ]),
  },
  methods: {
    ...mapActions(useTourOperatorsStore, ['getCurrent']),
  },
  async mounted() {
    const tourOperatorRes = await this.getCurrent();
    this.isPaxDataAllowed = Boolean(tourOperatorRes.isPaxDataUploadEnabled);
    this.isFlightSearchAllowed = Boolean(tourOperatorRes.isPoolingEnabled);
  }
};
</script>
